<template>
	<div v-if="story">
		<InformationBar v-if="informationBar" :blok="informationBar" />
		<div class="space-y-section">
			<StoryblokComponent v-if="story.content" :blok="story.content" />
		</div>
	</div>
</template>

<script lang="ts" setup>
	import {useRouteParams} from '@vueuse/router';
	import {storeToRefs} from 'pinia';
	import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';
	import type {PageTypeLeafletListingStoryblok} from '~/storyblok/types';
	import {DEFAULT_HYPERMARKET, GLOBAL_BRANCH_SLUG} from '#shared/constants';
	import {getBranchStoryblokSlug} from '~/utils/branch';

	definePageMeta({title: 'Letáky | Globus'});

	const branch = useRouteParams<string>('branch');
	const defaultHypermarket = computed(() => branch.value === GLOBAL_BRANCH_SLUG ? DEFAULT_HYPERMARKET : branch.value);

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarketInstance} = storeToRefs(hypermarketsStore);

	const informationBar = computed(() => {
		const bar = selectedHypermarketInstance.value?.content.informationBar![0];
		return bar && bar.visibleOnPages?.includes('PageTypeLeafletListing') ? bar : null;
	});

	const fullSlug = computed(() => getBranchStoryblokSlug(defaultHypermarket.value, 'letaky'));
	const {data: story, error, status} = await useSingleStoryFetch<PageTypeLeafletListingStoryblok>(
		fullSlug,
		{},
		{watch: [defaultHypermarket]},
	);

	if (error.value) {
		await tryDynamicRedirectOrShowError(error.value);
	} else if (status.value === 'success' && !story.value) {
		await tryDynamicRedirectOrShowError({statusCode: 404});
	}

	useSelectedHypermarketRouteSync(branch);

	useMetaTitle(story.value?.content.title?.length ? story.value?.content.title : 'Letáky' + ' | Globus');
</script>
